//*******************************************************
// global
//*******************************************************

// import './library/global.js';

//*******************************************************
// styles
//*******************************************************

import '../scss/main.scss';


$('#toggle-search').on('click', function() {
  const $this = $(this);
  /* eslint-disable no-magic-numbers */
  if ($(window).width() < 992) {
    // on mobile, submit form rather than revealing input
    $this.closest('form').submit();
    return;

  }
  const $input = $('#siteSearch');
  if ($input.hasClass('show')) {
    $input.removeClass('show');
    $this.attr('aria-expanded', 'false');

  } else {

    $input.addClass('show').focus();
    $this.attr('aria-expanded', 'true');
  }
});

const debounce = require('debounce');
$(function() {

  if ($('.submenu--button').length) {

    window.onresize = debounce(onresize, 200);
    onresize();
  }

  function onresize() {
    if (window.innerWidth > 991.9) {

      // desktop remove submenu from header and default to open
      $('.header--login').show();
      $('.header--submenu').remove();

      // specify .container to not auto-open on full-width pages
      $('.container .submenu--button').dropdown('show');
    } else {
      if ($('.header--submenu').length < 1) {
        $('.submenu--button').dropdown('hide');
        // mobile. move submenu into header
        const $submenu = $('.submenu').clone();
        $submenu.find('.submenu--button').attr('data-boundary', 'viewport')
          .attr('data-display', 'static');
        $submenu.addClass('header--submenu col-6').removeClass('submenu');

        $('.header--login').hide()
          .after($submenu);
      }
    }
  }
});
$('.box--expandable--trigger').on('click', function() {
  const $this = $(this);
  $this.closest('.box--expandable').find('.box--expandable--content')
    .toggleClass('show');
  $this.find('.fas').toggleClass('fa-plus fa-minus');
});
/* eslint-disable no-console */
console.log('main.js');
